// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kpi-header[data-v-786a5cb1] {\n  border-bottom: 0.02667rem solid var(--yq-border-color);\n  padding-bottom: 0.53333rem !important;\n}\n.form-div[data-v-786a5cb1] {\n  margin-top: 0.53333rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
